import { getPatientQueryOptions } from '@/api/queries/patients';
import { getProcedureQueryOptions } from '@/api/queries/procedures';
import { TreatmentMenu } from '@/components/cockpit/treatmentMenu';
import { ProcedureHeader } from '@/components/procedures/procedureHeader';
import { CockpitProvider } from '@/context/cockpitContext';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_plain/cockpit/$procedureId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { procedureId } = Route.useParams();
  const { data: procedure } = useSuspenseQuery(getProcedureQueryOptions(procedureId));
  const { data: patient } = useSuspenseQuery(getPatientQueryOptions(procedure.patient.id));

  return (
    <section className="size-full flex flex-col flex-1 min-h-0 gap-space-lg">
      <header className="flex flex-col space-y-space-2xs overflow-hidden">
        <ProcedureHeader procedure={ procedure } patient={ patient } />
      </header>

      <CockpitProvider>
        <div className="flex p-4 bg-white rounded-surface">
          <TreatmentMenu
            activeTargets={ procedure.activeTargets }
            procedureId={ procedureId }
            planningStatus={ procedure.planningStatus }
          />
        </div>

        <div className="flex flex-1 min-h-0 overflow-hidden">
          <Outlet />
        </div>
      </CockpitProvider>
    </section>
  );
}
